<template>
    <div class="read-only-banner" role="status">
        Maintenance on Monday 26 October from 16:00 to about 17:00 (UK time): the CMS is read-only.
        You can view everything, but changes can't be saved during that time.
    </div>
</template>

<script>
// Temporary: shown while the CMS databases move to another cluster (T3-1). Remove after the move.
export default {
    name: 'ReadOnlyBanner',
    mounted() {
        document.body.classList.add('has-read-only-banner');
    },
    beforeDestroy() {
        document.body.classList.remove('has-read-only-banner');
    },
};
</script>

<style lang="scss" scoped>
.read-only-banner {
    z-index: $header-z-index;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 32px;
    padding: 0 16px;
    overflow: hidden;
    background-color: #ffd84d;
    color: #3a2e00;
    font-size: 14px;
    font-weight: 600;
    line-height: 32px;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>

<style lang="scss">
// Push the page and the fixed side navigation below the banner
body.has-read-only-banner {
    padding-top: 32px;

    .nav {
        top: 32px !important;
        height: calc(100% - 32px) !important;
    }
}
</style>
